// Must match api/v2/app/Support/PremiumPlans.php (price is enforced server-side).
export const PREMIUM_PLANS = [
  { code: 'premium_6m', price: 199, validity: '6 Months', months: 6 },
  { code: 'premium_1y', price: 299, validity: '1 Year', months: 12, popular: true },
  { code: 'premium_2y', price: 399, validity: '2 Years', months: 24 },
];

export const planFeatures = (plan) => [
  'Lifetime Registration',
  'View 50 Profiles Per Day',
  'Message 20 Profiles Per Day',
  `Chat / Message Feature For ${plan.validity}`,
];

export const validityLabel = (months) => {
  if (!months || months <= 0) return '';
  if (months % 12 === 0) {
    const years = months / 12;
    return `${years} ${years === 1 ? 'Year' : 'Years'}`;
  }
  return `${months} Months`;
};

const parseDate = (value) => {
  if (!value) return null;
  const normalized = value.toString().replace(/^(\d{4}-\d{2}-\d{2}):/, '$1 ').replace(' ', 'T');
  const date = new Date(normalized);
  return Number.isNaN(date.getTime()) ? null : date;
};

// Validity of a purchased plan, derived from its stored dates so older
// purchases (e.g. ₹99 annual) still show what they actually bought.
export const purchasedValidityLabel = (validFrom, validUpto) => {
  const from = parseDate(validFrom);
  const upto = parseDate(validUpto);
  if (!from || !upto) return '';
  const months = Math.round((upto - from) / (1000 * 60 * 60 * 24 * 30.44));
  return validityLabel(months);
};
